import { BaseMarker } from '../base/baseMarker'
import { RectangleMarkerController } from './rectangleMarkerController'
import { RectangleMarkerRenderer } from './rectangleMarkerRenderer'
import { RectangleMarkerStateManager } from './rectangleMarkerStateManager'
import { RectangleMarkerHandles } from './rectangleMarkerHandles'
import { pointToSegmentDistance } from '../../helperFunctions'

class RectangleMarker extends BaseMarker<
  RectangleMarkerStateManager,
  RectangleMarkerRenderer,
  RectangleMarkerController,
  RectangleMarkerHandles
> {
  constructor() {
    super()
    this.controller = new RectangleMarkerController(this)
    this.renderer = new RectangleMarkerRenderer(this)
    this.state = new RectangleMarkerStateManager(this)
    this.handles = new RectangleMarkerHandles(this)
  }

  public static typeName = 'RectangleMarker'

  getMouseToShapeDistance(): number {
    const state = this.state
    const controller = this.controller
    const position = state.position
    const dimensions = state.dimensions
    const mouseX = controller.mouseX
    const mouseY = controller.mouseY
    const x = position.x
    const y = position.y
    const height = dimensions.height
    const width = dimensions.width

    const vertices = [
      { x: x, y: y }, // Top-left vertex
      { x: x + width, y: y }, // Top-right vertex
      { x: x + width, y: y + height }, // Bottom-right vertex
      { x: x, y: y + height },
    ]

    let minDist = Infinity

    vertices.forEach((vertex, i) => {
      const v1 = vertex
      const v2 = vertices[(i + 1) % vertices.length] // Wrap around to the first vertex
      const dist = pointToSegmentDistance(mouseX, mouseY, v1.x, v1.y, v2.x, v2.y)
      if (dist < minDist) {
        minDist = dist
      }
    })
    return minDist
  }

  isMousedOver() {
    const mouseX = this.controller.mouseX
    const mouseY = this.controller.mouseY
    const x = this.state.position?.x
    const y = this.state.position?.y
    const width = this.state.dimensions?.width
    const height = this.state.dimensions?.height
    const markerMousedOver = mouseX >= x && mouseX <= x + width && mouseY >= y && mouseY <= y + height
    const handleMousedOver = this.handles.getMousedOverHandle() !== undefined

    return markerMousedOver || handleMousedOver
  }

  /**
   * Whether the rectangle marker has all information needed to be rendered
   * @returns boolean
   */
  isRectDefined(): boolean {
    const x = this.state.position?.x
    const y = this.state.position?.y
    const width = this.state.dimensions?.height
    const height = this.state.dimensions?.width

    return x !== undefined && y !== undefined && width !== undefined && height !== undefined
  }
}

export { RectangleMarker }
